import {apiPost, apiGet} from './api';

export function login(usuario, password) {
  const data = {
    Usuario: usuario,
    Password: password,
  };
  return apiPost('/recibos/login', data);
}
export function validarToken() {
  return apiGet('/utilidades/Token', {});
}
